// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fuU1","col":"styles_col__3juxY"};